export const ANKHEG_ACID_SPRAY_ID = 'monster-action:ankheg:acid-spray';

const ACID_SPRAY = Object.freeze({
  id: ANKHEG_ACID_SPRAY_ID, displayName: 'Acid Spray', saveLabel: 'DEX Save • DC 12',
  damageLabel: '4d6 Acid', rechargeLabel: 'Recharge 6',
  areaLabel: '30-ft × 5-ft line • manual targeting',
});

// Classification is an explicit identity/action overlay, not description parsing.
export const getSupportedMonsterSaveAction = (enemy, action) => (
  enemy?.index === 'ankheg' && enemy?.source === '5e-srd' && action?.name === 'Acid Spray (Recharge 6)'
    ? ACID_SPRAY : null
);

export const createEnemySaveActionTargeting = (enemy, action) => {
  const definition = getSupportedMonsterSaveAction(enemy, action);
  const sourceCombatantId = enemy?.enemyId || enemy?._id;
  if (!definition || !sourceCombatantId) return null;
  return { status: 'selecting-target', actionType: 'save-damage', sourceCombatantId,
    sourceActionId: definition.id, attacker: enemy, action, definition, manualSingleTarget: true };
};
